// extracted by mini-css-extract-plugin
export var fullHeightState = "_22-7";
export var headerCell = "_22-1";
export var loadingStateCell = "_22-4";
export var rowWrapper = "_22-3";
export var standaloneTable = "_22-8";
export var standaloneTableWithBodyFill = "_22-9";
export var stateCell = "_22-5";
export var table = "_22-0";
export var tableBodyFiller = "_22-6";
export var white = "_22-2";